import { Trophy } from "lucide-react";

function formatNumber(n) {
  if (n == null) return "0";
  return n.toLocaleString("pt-BR");
}

export default function DoletasGalaInfo({ galaEvent }) {
  if (!galaEvent) return null;
  var prizes = galaEvent.prizes || [];
  if (prizes.length === 0) return null;

  var colors = ["bg-amber-50 border-amber-200", "bg-gray-50 border-gray-200", "bg-orange-50 border-orange-200"];
  var textColors = ["text-amber-700", "text-gray-600", "text-orange-700"];

  var prizeCards = [];
  for (var i = 0; i < prizes.length; i++) {
    prizeCards.push(
      <div key={i} className={"border rounded-xl p-3 " + (colors[i] || "bg-gray-50 border-gray-200")}>
        <p className={"text-xs font-bold " + (textColors[i] || "text-gray-600")}>{prizes[i].place}o Lugar</p>
        <p className="text-sm font-medium text-[#0A2F3D] mt-1">{prizes[i].description}</p>
        <p className="text-xs text-gray-500 mt-1">Min: {formatNumber(prizes[i].min_doletas)} doletas</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4 lg:p-5 mb-4">
      <div className="flex items-center gap-2 mb-3">
        <Trophy className="w-5 h-5 text-amber-500" />
        <h4 className="font-semibold text-[#0A2F3D] text-sm">{galaEvent.name || "Noite de Gala METHOS"}</h4>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">{prizeCards}</div>
    </div>
  );
}
